import {Injectable} from '@angular/core';

@Injectable()
export class WindowService {

  constructor() {}

  get windowRef() {
    return window;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/window/window.service.ts